var _path, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinority(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 750,
    fill: "none",
    viewBox: "0 0 750 750",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m750 750h-750v-750h750z",
    fill: "url(#radialGradient1497)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient1497",
    cx: 679.17,
    cy: 677.82,
    r: 375,
    gradientTransform: "matrix(5.8541e-7 -2.9645 2.314 7.0685e-7 -818.48 2763.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151371",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00B8",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700",
    offset: 0.91223
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.3995 -101.97)",
    fill: "#fff",
    strokeWidth: 0.2815
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96.834,
    y: 400.26,
    width: 81.916,
    height: 232.52
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.95,
    y: 401.66,
    width: 81.635,
    height: 232.52
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.75,
    y: 319.75,
    width: 82.198,
    height: 81.916
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.22,
    y: 401.66,
    width: 82.198,
    height: 232.52
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.58,
    y: 319.75,
    width: 81.635,
    height: 81.916
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.41,
    y: 319.75,
    width: 81.916,
    height: 81.916
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.33,
    y: 391.81,
    width: 81.635,
    height: 81.916
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.41,
    y: 473.73,
    width: 81.916,
    height: 81.635
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinority);
export default __webpack_public_path__ + "static/media/minority.552fb880ee806c3b1711b57e9540979c.svg";
export { ForwardRef as ReactComponent };